import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ testid = "share-button", className = "" }) => {
  const handleShare = async () => {
    const shareData = {
      title: "La Petite Boîte Intuitive",
      text: "Une question de cœur ? J'ai consulté le Tarot sur La Petite Boîte Intuitive ✨",
      url: window.location.origin,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(`${shareData.text} ${shareData.url}`);
        toast.success("Lien copié — partage-le où tu veux.");
      }
    } catch (e) {
      // partage annulé par l'utilisateur : rien à faire
    }
  };

  return (
    <button
      data-testid={testid}
      onClick={handleShare}
      className={`inline-flex items-center gap-2 font-body text-xs tracking-[0.12em] uppercase transition-colors ${className}`}
      style={{ color: "#A2A2A6" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "#E6C687")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "#A2A2A6")}
    >
      <Share2 size={14} strokeWidth={1.5} />
      Partager l'expérience
    </button>
  );
};
